/**
 * tranform keys from object
 * @param obj target object
 * @param transformFn function to transform key
 * @param ignoreKeys keys that your content will not be transformed
 * @returns object with keys transformed
 */

type TransformKeysOptions = {
  transformFn: (v: string) => string;
  ignoreKeys?: string[];
  preserveKeys?: string[];
};
export default function transformKeys(
  obj: any,
  options: TransformKeysOptions,
): any {
  const { transformFn, ignoreKeys = [], preserveKeys = [] } = options;
  if (Array.isArray(obj)) {
    return obj.map(item => transformKeys(item, options));
  } else if (obj !== null && typeof obj === 'object') {
    return Object.keys(obj).reduce((acc: any, key: string) => {
      const newKey = transformFn(key);
      if (preserveKeys.includes(key)) {
        acc[key] = transformKeys(obj[key], options);
      } else if (ignoreKeys.includes(key)) {
        acc[newKey] = obj[key];
      } else {
        acc[newKey] = transformKeys(obj[key], options);
      }
      return acc;
    }, {});
  }
  return obj;
}
